import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_ScanHistory {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadScan(SchoolID, PersonID, StartDate, EndDate, IsStaff) {
		var postResult$ = new Subject();
		var url = "Staff/LoadScan?SchoolID=" + SchoolID + "&PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate + "&IsStaff=" + IsStaff;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanSelect(ScanID) {
		var postResult$ = new Subject();
		var url = "Staff/ScanSelect?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
